
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import WhatsAppButton from '../../../components/feature/WhatsAppButton';
import SEOHead from '../../../components/SEO/SEOHead';

export default function Product5Page() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('overview');
  const [selectedImage, setSelectedImage] = useState(0);

  // Fallback image for any failed loads
  const placeholderImg = 'https://via.placeholder.com/600x400?text=Image+Not+Found';

  const handleImageError = (e) => {
    e.target.onerror = null; // Prevent infinite loop if placeholder also fails
    e.target.src = placeholderImg;
  };

  const seoData = {
    title: 'چسب ترمیم پلاستیک گلخانه - گلخانه سبز آریا',
    description: 'چسب ترمیم پلاستیک گلخانه با کیفیت بالا، شفاف و مقاوم در برابر آب و هوا. مناسب برای ترمیم سریع پارگی‌های پلاستیک گلخانه.',
    keywords: 'چسب ترمیم پلاستیک، چسب گلخانه، ترمیم پلاستیک، چسب شفاف، چسب مقاوم UV، تعمیر گلخانه، چسب کشاورزی، ترمیم نایلون گلخانه',
    ogImage: 'https://public.readdy.ai/ai/img_res/7e1630fd1d5d194409c6100e00927958.jpg',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "چسب ترمیم پلاستیک گلخانه",
      "description": "چسب شفاف با کیفیت بالا برای ترمیم پلاستیک گلخانه، مقاوم در برابر آب و هوا و اشعه UV",
      "image": [
        "https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography%20clear%20material&width=800&height=600&seq=repair-tape-1&orientation=landscape",
        "https://readdy.ai/api/search-image?query=transparent%20repair%20tape%20roll%20close%20up%20high%20quality%20adhesive%20material%20for%20greenhouse%20maintenance&width=800&height=600&seq=repair-tape-2&orientation=landscape"
      ],
      "brand": {
        "@type": "Brand",
        "name": "گلخانه سبز آریا"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "گلخانه سبز آریا"
      },
      "sku": "REPAIR-TAPE-001",
      "mpn": "RT5CM-2024",
      "gtin": "1234567890125",
      "category": "ابزار و تجهیزات گلخانه",
      "offers": {
        "@type": "Offer",
        "url": "https://ariagreenhouse.com/products/5",
        "priceCurrency": "IRR",
        "price": "45000",
        "priceValidUntil": "2024-12-31",
        "availability": "https://schema.org/InStock",
        "seller": {
          "@type": "Organization",
          "name": "گلخانه سبز آریا"
        },
        "itemCondition": "https://schema.org/NewCondition",
        "warranty": "P6M"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "127",
        "bestRating": "5",
        "worstRating": "1"
      },
      "review": [
        {
          "@type": "Review",
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "bestRating": "5"
          },
          "author": {
            "@type": "Person",
            "name": "احمد محمدی"
          },
          "reviewBody": "کیفیت فوق‌العاده‌ای داره. گیاهانم خیلی بهتر رشد کردن. حتماً دوباره سفارش می‌دم."
        }
      ],
      "additionalProperty": [
        {
          "@type": "PropertyValue",
          "name": "عرض",
          "value": "5 سانتی‌متر"
        },
        {
          "@type": "PropertyValue",
          "name": "طول",
          "value": "25 متر"
        },
        {
          "@type": "PropertyValue",
          "name": "ضخامت",
          "value": "0.1 میلی‌متر"
        },
        {
          "@type": "PropertyValue",
          "name": "دمای کاری",
          "value": "-20 تا +80 درجه"
        },
        {
          "@type": "PropertyValue",
          "name": "مقاومت UV",
          "value": "بالا"
        }
      ]
    }
  };

  const productImages = [
    'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20transparent%20adhesive%20tape%20for%20agricultural%20use%20professional%20quality%20white%20background%20product%20photography%20clear%20material&width=600&height=450&seq=repair-tape-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=transparent%20repair%20tape%20roll%20close%20up%20high%20quality%20adhesive%20material%20for%20greenhouse%20maintenance%20detailed%20view&width=600&height=450&seq=repair-tape-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20tape%20application%20process%20professional%20maintenance%20work%20agricultural%20equipment&width=600&height=450&seq=repair-tape-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=repaired%20greenhouse%20plastic%20with%20transparent%20tape%20successful%20maintenance%20result%20clear%20adhesive&width=600&height=450&seq=repair-tape-4&orientation=landscape'
  ];

  const relatedProducts = [
    {
      id: 3,
      name: 'نخ UV گلخانه',
      price: '۸۵,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=UV%20resistant%20greenhouse%20twine%20rope%20for%20plant%20support%20professional%20agricultural%20equipment%20white%20background%20modern%20product%20photography&width=300&height=200&seq=uv-twine-related&orientation=landscape'
    },
    {
      id: 4,
      name: 'توری ضد تریپس',
      price: '۱۲۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=anti-thrips%20insect%20screen%20mesh%20for%20greenhouse%20protection%20fine%20mesh%20agricultural%20netting%20white%20background%20professional%20product%20photography&width=300&height=200&seq=thrips-net-related&orientation=landscape'
    },
    {
      id: 1,
      name: 'کوکوپیت پریمیوم',
      price: '۲۵۰,۰۰۰ تومان',
      image: 'https://readdy.ai/api/search-image?query=premium%20coconut%20coir%20substrate%20blocks%20for%20greenhouse%20cultivation%20professional%20agricultural%20growing%20medium%20clean%20white%20background%20high%20quality%20product%20photography&width=300&height=200&seq=coco-premium-related&orientation=landscape'
    }
  ];

  const tabs = [
    { id: 'overview', name: 'نمای کلی', icon: 'ri-eye-line' },
    { id: 'specifications', name: 'مشخصات', icon: 'ri-file-list-3-line' },
    { id: 'usage', name: 'راهنمای استفاده', icon: 'ri-book-open-line' },
    { id: 'applications', name: 'کاربردها', icon: 'ri-tools-line' },
    { id: 'benefits', name: 'مزایا', icon: 'ri-star-line' }
  ];

  return (
    <div className="min-h-screen">
      <SEOHead {...seoData} />
      <Header />

      {/* Breadcrumb */}
      <section className="bg-gray-50 py-4 pt-24 mt-20">
        <div className="container mx-auto px-4 lg:px-8">
          <nav className="flex items-center space-x-2 text-sm">
            <Link to="/" className="text-gray-500 hover:text-emerald-600 cursor-pointer">خانه</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <Link to="/products" className="text-gray-500 hover:text-emerald-600 cursor-pointer">محصولات</Link>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
            <span className="text-gray-800 font-medium">چسب ترمیم پلاستیک گلخانه</span>
          </nav>
        </div>
      </section>

      {/* Product Details */}
      <section className="py-12">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Product Images */}
            <div>
              <div className="mb-4">
                <img
                  src={productImages[selectedImage]}
                  alt="چسب ترمیم پلاستیک گلخانه"
                  className="w-full h-96 object-cover object-top rounded-2xl shadow-lg"
                  onError={handleImageError}
                />
              </div>
              <div className="grid grid-cols-4 gap-2">
                {productImages.map((image, index) => (
                  <button
                    key={index}
                    onClick={() => setSelectedImage(index)}
                    className={`border-2 rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                      selectedImage === index ? 'border-emerald-500' : 'border-gray-200 hover:border-gray-300'
                    }`}
                  >
                    <img
                      src={image}
                      alt={`تصویر ${index + 1}`}
                      className="w-full h-20 object-cover object-top"
                      onError={handleImageError}
                    />
                  </button>
                ))}
              </div>
            </div>

            {/* Product Info */}
            <div>
              <div className="mb-6">
                <span className="bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-sm font-medium">
                  محصول جدید
                </span>
              </div>

              <h1 className="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
                چسب ترمیم پلاستیک گلخانه
              </h1>

              <p className="text-xl text-gray-600 mb-6 leading-relaxed">
                چسب شفاف با کیفیت بالا برای ترمیم پلاستیک گلخانه، مقاوم در برابر آب و هوا و اشعه UV
              </p>

              {/* Rating */}
              <div className="flex items-center mb-6">
                <div className="flex items-center text-yellow-500 ml-3">
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                  <i className="ri-star-fill"></i>
                </div>
                <span className="text-gray-600">۴.۸ از ۵ (۱۲۷ نظر)</span>
              </div>

              {/* Key Features */}
              <div className="mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">ویژگی‌های کلیدی:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">شفافیت بالا</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">چسبندگی قوی</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">مقاوم در برابر آب و هوا</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">آسان الاستفاده</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">بدون باقی‌مانده</span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <i className="ri-check-line text-emerald-600"></i>
                    <span className="text-gray-700">مقاوم در برابر UV</span>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-phone-line ml-2"></i>
                  استعلام قیمت و سفارش
                </button>
                <button className="flex-1 border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 px-6 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-download-line ml-2"></i>
                  دانلود کاتالوگ
                </button>
              </div>

              {/* Contact Info */}
              <div className="bg-gray-50 p-6 rounded-2xl">
                <h4 className="font-semibold text-gray-800 mb-3">تماس برای مشاوره:</h4>
                <div className="space-y-2">
                  <div className="flex items-center space-x-3">
                    <i className="ri-phone-line text-emerald-600"></i>
                    <span className="text-gray-700">۰۲۱۸۸۴۴۱۳۸۶</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-smartphone-line text-emerald-600"></i>
                    <span className="text-gray-700">۰۹۱۲۹۰۹۵۳۰۲</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Tabs */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 lg:px-8">
          {/* Tab Navigation */}
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'bg-emerald-600 text-white'
                    : 'bg-white text-gray-700 hover:bg-emerald-50 border border-gray-200'
                }`}
              >
                <i className={`${tab.icon} text-lg`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="bg-white rounded-3xl p-8 shadow-lg">
            {activeTab === 'overview' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">نمای کلی محصول</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      چسب ترمیم پلاستیک گلخانه یکی از ضروری‌ترین تجهیزات برای نگهداری و تعمیر گلخانه‌ها محسوب می‌شود. این محصول با کیفیت بالا و شفافیت عالی، امکان ترمیم سریع و مؤثر پارگی‌ها و سوراخ‌های پلاستیک گلخانه را فراهم می‌کند.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-6">
                      این چسب با فرمولاسیون ویژه طراحی شده که در برابر شرایط جوی مختلف از جمله باران، برف، آفتاب و تغییرات دما مقاومت بالایی دارد. همچنین دارای چسبندگی قوی و ماندگاری طولانی است.
                    </p>
                    <div className="bg-emerald-50 p-4 rounded-xl">
                      <h4 className="font-semibold text-emerald-800 mb-2">نکته مهم:</h4>
                      <p className="text-emerald-700 text-sm">
                        استفاده از چسب با کیفیت برای ترمیم پلاستیک گلخانه، از هدر رفت انرژی جلوگیری کرده و عمر مفید گلخانه را افزایش می‌دهد.
                      </p>
                    </div>
                  </div>
                  <div>
                    <img
                      src="https://readdy.ai/api/search-image?query=greenhouse%20plastic%20repair%20process%20professional%20application%20of%20transparent%20tape%20on%20greenhouse%20covering%20agricultural%20maintenance%20work%20clean%20environment&width=500&height=400&seq=repair-process&orientation=landscape"
                      alt="فرآیند ترمیم پلاستیک گلخانه"
                      className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                      onError={handleImageError}
                    />
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'specifications' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مشخصات فنی</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مشخصات کلی:</h4>
                    <div className="space-y-3">
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">عرض:</span>
                        <span className="font-medium">۵ سانتی‌متر</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">طول:</span>
                        <span className="font-medium">۲۵ متر</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">ضخامت:</span>
                        <span className="font-medium">۰.۱ میلی‌متر</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">دمای کاری:</span>
                        <span className="font-medium">-۲۰ تا +۸۰ درجه</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">مقاومت UV:</span>
                        <span className="font-medium">بالا</span>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">ویژگی‌های فنی:</h4>
                    <div className="space-y-3">
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">شفافیت:</span>
                        <span className="font-medium">۹۵٪</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">قدرت چسبندگی:</span>
                        <span className="font-medium">۱۸ N/cm</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">مقاومت کششی:</span>
                        <span className="font-medium">۴۵ N/cm</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">ماندگاری:</span>
                        <span className="font-medium">۲-۳ سال</span>
                      </div>
                      <div className="flex justify-between border-b border-gray-200 pb-2">
                        <span className="text-gray-600">مواد:</span>
                        <span className="font-medium">پلی‌اتیلن</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'usage' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">راهنمای استفاده</h3>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">نحوه استفاده از چسب ترمیم:</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۱</div>
                          <div>
                            <h5 className="font-medium text-gray-800">تمیز کردن سطح</h5>
                            <p className="text-gray-600 text-sm">سطح پلاستیک را کاملاً تمیز و خشک کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۲</div>
                          <div>
                            <h5 className="font-medium text-gray-800">اندازه‌گیری</h5>
                            <p className="text-gray-600 text-sm">طول مورد نیاز چسب را اندازه‌گیری کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۳</div>
                          <div>
                            <h5 className="font-medium text-gray-800">چسباندن</h5>
                            <p className="text-gray-600 text-sm">چسب را به آرامی روی پارگی قرار دهید</p>
                          </div>
                        </div>
                      </div>
                      <div className="space-y-4">
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۴</div>
                          <div>
                            <h5 className="font-medium text-gray-800">فشار دادن</h5>
                            <p className="text-gray-600 text-sm">با دست یا ابزار مناسب فشار دهید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۵</div>
                          <div>
                            <h5 className="font-medium text-gray-800">بررسی</h5>
                            <p className="text-gray-600 text-sm">از چسبیدن کامل اطمینان حاصل کنید</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-3">
                          <div className="w-8 h-8 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-sm">۶</div>
                          <div>
                            <h5 className="font-medium text-gray-800">تست نهایی</h5>
                            <p className="text-gray-600 text-sm">عملکرد ترمیم را بررسی کنید</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="bg-yellow-50 p-6 rounded-xl">
                    <h4 className="font-semibold text-yellow-800 mb-3">نکات مهم:</h4>
                    <ul className="space-y-2 text-yellow-700">
                      <li className="flex items-center space-x-2">
                        <i className="ri-alert-line"></i>
                        <span>از استفاده در دمای زیر صفر درجه خودداری کنید</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <i className="ri-alert-line"></i>
                        <span>سطح باید کاملاً خشک باشد</span>
                      </li>
                      <li className="flex items-center space-x-2">
                        <i className="ri-alert-line"></i>
                        <span>از تماس مستقیم با آتش دوری کنید</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'applications' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">کاربردها</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-home-garden-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">گلخانه‌های تجاری</h4>
                    <p className="text-gray-600 text-sm">ترمیم پلاستیک گلخانه‌های بزرگ و تجاری</p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-plant-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">گلخانه‌های خانگی</h4>
                    <p className="text-gray-600 text-sm">تعمیر و نگهداری گلخانه‌های کوچک</p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-seedling-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">نهالستان‌ها</h4>
                    <p className="text-gray-600 text-sm">حفاظت از نهال‌ها در برابر آب و هوا</p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-leaf-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">کشت هیدروپونیک</h4>
                    <p className="text-gray-600 text-sm">نگهداری سیستم‌های کشت بدون خاک</p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-sun-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">تونل‌های کشاورزی</h4>
                    <p className="text-gray-600 text-sm">ترمیر پوشش تونل‌های پلاستیکی</p>
                  </div>

                  <div className="bg-gray-50 p-6 rounded-xl">
                    <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                      <i className="ri-shield-line text-emerald-600 text-xl"></i>
                    </div>
                    <h4 className="font-semibold text-gray-800 mb-2">محافظت از محصولات</h4>
                    <p className="text-gray-600 text-sm">حفاظت موقت از گیاهان در فصول سرد</p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'benefits' && (
              <div>
                <h3 className="text-2xl font-bold text-gray-800 mb-6">مزایا و فواید</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مزایای اقتصادی:</h4>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <i className="ri-money-dollar-circle-line text-emerald-600"></i>
                        <span className="text-gray-700">صرفه‌جویی در هزینه تعویض پلاستیک</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-time-line text-emerald-600"></i>
                        <span className="text-gray-700">افزایش عمر مفید گلخانه</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-tools-line text-emerald-600"></i>
                        <span className="text-gray-700">کاهش هزینه‌های تعمیر و نگهداری</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-leaf-line text-emerald-600"></i>
                        <span className="text-gray-700">جلوگیری از هدر رفت انرژی</span>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-800 mb-4">مزایای فنی:</h4>
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3">
                        <i className="ri-shield-check-line text-emerald-600"></i>
                        <span className="text-gray-700">مقاومت بالا در برابر شرایط جوی</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-eye-line text-emerald-600"></i>
                        <span className="text-gray-700">شفافیت عالی و عدم تأثیر بر نور</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-hand-heart-line text-emerald-600"></i>
                        <span className="text-gray-700">آسان الاستفاده و نصب سریع</span>
                      </div>
                      <div className="flex items-center space-x-3">
                        <i className="ri-recycle-line text-emerald-600"></i>
                        <span className="text-gray-700">سازگار با محیط زیست</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-8 bg-emerald-50 p-6 rounded-xl">
                  <h4 className="font-semibold text-emerald-800 mb-3">چرا محصولات ما را انتخاب کنید؟</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex items-center space-x-2">
                      <i className="ri-award-line text-emerald-600"></i>
                      <span className="text-emerald-700">کیفیت تضمین شده</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-customer-service-2-line text-emerald-600"></i>
                      <span className="text-emerald-700">پشتیبانی فنی ۲۴/۷</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-truck-line text-emerald-600"></i>
                      <span className="text-emerald-700">ارسال سریع به سراسر کشور</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-price-tag-3-line text-emerald-600"></i>
                      <span className="text-emerald-700">قیمت مناسب و رقابتی</span>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Related Products */}
      <section className="py-16">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">محصولات مرتبط</h2>
            <p className="text-gray-600">سایر محصولات مورد نیاز گلخانه شما</p>
          </div>

          {/* Related Products */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-product-shop>
            {relatedProducts.map((product) => (
              <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-48 object-cover object-top"
                  onError={handleImageError}
                />
                <div className="p-6">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">{product.name}</h3>
                  <p className="text-emerald-600 font-bold mb-4">{product.price}</p>
                  <Link
                    to={`/products/${product.id}`}
                    className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white text-center py-2 rounded-full font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    مشاهده جزئیات
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-emerald-600">
        <div className="container mx-auto px-4 lg:px-8 text-center text-white">
          <h2 className="text-3xl font-bold mb-4">آماده سفارش هستید؟</h2>
          <p className="text-xl mb-8 text-emerald-100">
            با تیم متخصص ما تماس بگیرید و مشاوره رایگان دریافت کنید
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-emerald-600 hover:bg-gray-100 px-8 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-phone-line ml-2"></i>
              تماس برای سفارش
            </button>
            <button className="border-2 border-white text-white hover:bg-white hover:text-emerald-600 px-8 py-3 rounded-full font-semibold transition-colors cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line ml-2"></i>
              چت در واتساپ
            </button>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
